import { createAsyncThunk } from '@reduxjs/toolkit';
import NEWAPI from '../../API/newIndex';

export const upload = createAsyncThunk('upload/upload', async (payload, { rejectWithValue }) => {
  try {
    const res = await NEWAPI({
      url: '/admin/fileupload/upload',
      method: 'POST',
      data: payload,
    });
    return res ?? null;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const updateImageByUrl = createAsyncThunk(
  'upload/updateImageByUrl',
  async (payload, { rejectWithValue }) => {
    try {
      // Convert payload into FormData
      const formData = new FormData();
      formData.append('file', payload.file); // BINARY FILE
      formData.append('folder', payload.folder);

      const res = await NEWAPI({
        url: `/admin/fileupload/updateImageByUrl?url=${payload.url}`,
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data', // REQUIRED FOR BINARY FILE
        },
      });

      return res ?? null;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fileUploadItem = createAsyncThunk(
  'upload/fileUploadItem',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await NEWAPI({
        url: `/admin/fileupload/fileUpload`,
        method: 'POST',
        data: payload,
      });

      return res ?? null;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
